import StudentStoriesSlider from '@/ui/Slidersection';


const StudentStoriesSection = ({studentStoriesData}) => {

  return (
    <div className='max-w-(--max-page-width) mx-auto px-(--container-padding) mb-16'>
      <StudentStoriesSlider
        title={studentStoriesData.title}
        subText={studentStoriesData.subText}
        students={studentStoriesData.students}
      />
    </div>
  );
};

export default StudentStoriesSection;
